import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import { useLocation } from 'react-router-dom';
import config from 'config';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { IconChevronDown, IconChevronUp } from '@tabler/icons';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import SourceIcon from '@mui/icons-material/Source';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import LinkIcon from '@mui/icons-material/Link';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import RuleIcon from '@mui/icons-material/Rule';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DvrIcon from '@mui/icons-material/Dvr';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ChurchIcon from '@mui/icons-material/Church';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
const iconMap = {
    IconDashboard: DashboardIcon,
    SettingsIcon: SettingsIcon,
    RequestQuoteIcon: RequestQuoteIcon,
    AccountTreeIcon: AccountTreeIcon,
    PeopleAltIcon: PeopleAltIcon,
    DescriptionIcon: DescriptionIcon,
    ReceiptLongIcon: ReceiptLongIcon,
    RequestPageIcon: RequestPageIcon,
    SourceIcon: SourceIcon,
    FileDownloadIcon: FileDownloadIcon,
    PictureAsPdfIcon: PictureAsPdfIcon,
    LinkIcon: LinkIcon,
    PointOfSaleIcon: PointOfSaleIcon,
    DynamicFeedIcon: DynamicFeedIcon,
    RuleIcon: RuleIcon,
    CloudDownloadIcon: CloudDownloadIcon,
    CancelScheduleSendIcon: CancelScheduleSendIcon,
    AssignmentLateIcon: AssignmentLateIcon,
    ReceiptIcon: ReceiptIcon,
    DvrIcon: DvrIcon,
    NoteAddIcon: NoteAddIcon,
    ChurchIcon: ChurchIcon,
    AdminPanelSettingsIcon: AdminPanelSettingsIcon

};
// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //
const getIconComponent = (iconName) => {
    return iconMap[iconName] || null;
    // Convierte el nombre del icono en un componente de icono dinámico
    // const IconComponent = icons[iconName];
    // if (IconComponent) {
    //     return <IconComponent />;
    // } else {
    //     // Si el icono no se encuentra, puedes manejarlo de acuerdo a tus necesidades.
    //     return 'null'; // O muestra un icono predeterminado en su lugar
    // }
};

const NavCollapse = ({ menu, level }) => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);

    const location = useLocation();

    // Check if any child is active based on location
    const checkIsActive = (children) => {
        if (!children) return false;
        return children.some(child => {
            if (child.type === 'collapse') {
                return checkIsActive(child.children);
            }
            if (child.url) {
                const currentUrl = `${config.basename}${child.url}`;
                return location.pathname === currentUrl || location.pathname.startsWith(currentUrl + '/');
            }
            return false;
        });
    };

    const isParentActive = checkIsActive(menu.children);

    // Auto-open if a child is active
    const [open, setOpen] = useState(isParentActive);

    useEffect(() => {
        if (isParentActive) {
            setOpen(true);
        }
    }, [isParentActive]);

    const handleClick = () => {
        setOpen(!open);
    };

    // // menu collapse & item
    const menus = menu.children?.map((item) => {

        switch (item.type) {
            case 'collapse':
                return <NavCollapse key={item.idMenuDetalle} menu={item} level={level + 1} />;
            case 'item':
                return <NavItem key={item.idMenuDetalle} item={item} level={level + 1} />;
            default:
                return (
                    <Typography key={item.idMenuDetalle} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    const IconComponent = getIconComponent(menu.icon);
    //const Icon = menu.icon;


    const menuIcon = IconComponent ? (
        <IconComponent strokeWidth={1.5} size="1.3rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: isParentActive ? 8 : 6,
                height: isParentActive ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    return (
        <>
            <ListItemButton
                sx={{
                    borderRadius: `${customization.borderRadius}px`,
                    mb: 0.5,
                    alignItems: 'center',
                    backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                    py: level > 1 ? 1 : 1.25,
                    pl: `${level * 24}px`,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : theme.palette.primary.light,
                        '& .MuiListItemIcon-root': {
                            color: theme.palette.primary.main
                        }
                    },
                    ...(isParentActive && {
                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(33, 150, 243, 0.15) !important' : `${theme.palette.primary.light} !important`,
                        color: theme.palette.primary.main,
                    })
                }}
                selected={isParentActive}
                onClick={handleClick}
            >
                <ListItemIcon sx={{
                    my: 'auto',
                    minWidth: !menu.icon ? 18 : 36,
                    color: isParentActive ? theme.palette.primary.main : 'inherit',
                    transition: 'all 0.3s ease'
                }}>
                    {menuIcon}
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography
                            variant={isParentActive ? 'h5' : 'body1'}
                            color="inherit"
                            sx={{
                                my: 'auto',
                                fontWeight: isParentActive ? 700 : 500,
                                color: isParentActive ? theme.palette.primary.main : 'inherit'
                            }}
                        >
                            {menu.title}
                        </Typography>
                    }
                    secondary={
                        menu.caption && (
                            <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                {menu.caption}
                            </Typography>
                        )
                    }
                />
                {open ? (
                    <IconChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto', color: theme.palette.primary.main }} />
                ) : (
                    <IconChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                )}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    component="div"
                    disablePadding
                    sx={{
                        position: 'relative',
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            left: '32px',
                            top: 0,
                            height: '100%',
                            width: '1px',
                            opacity: 0.5,
                            background: theme.palette.primary.main
                        }
                    }}
                >
                    {menus}
                </List>
            </Collapse>
        </>
    );
};

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number
};

export default NavCollapse;
